// extracted by mini-css-extract-plugin
module.exports = {"activityListItem":"_1SC_e","activityListItemDescription":"_2_YqO","descriptionTextWrapper":"H-Nf3","activityIconWrapper":"_3n9Rg","withPadding":"_3bs1V"};